import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseContainer from '../baseContainers/BaseContainer';
import InputTextComponent from "../components/inputs/InputTextComponent";

class MapFilterContainer extends BaseContainer {
    constructor(props) {
        super(props);
        this.state = {
            location: '',
            preventMultiAction: true
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    getContainerListName() {
        return 'map-filter-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    render() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <InputTextComponent
                    id='location'
                    name='location'
                    label='location'
                    showLabel={false}
                    placeholder={t('stationsMap.enterLocation')}
                    colClass='col-md-10 col-sm-12 map-location stations-map-1024up'
                    value={this.state.location}
                    viewMode='NEW'
                    validator={this.validator}
                    validators='not_required'
                    onChange={(inputType, parameters, event, onAfterStateChange, stateField) => {
                        if (!this.state.preventMultiAction) {
                            this.setState({preventMultiAction: true});
                        }
                        this.handleChange(inputType, parameters, event, onAfterStateChange, stateField);
                    }}
                    onBlur={(e) => {
                        if (this.state.preventMultiAction) {
                            this.setState({preventMultiAction: true});
                            this.props.onActionCallback(this.state.location);
                        }
                    }}
                    onKeyDown={(e) => {
                        this.setState({preventMultiAction: false});
                        if (e.key === 'Enter') {
                            this.props.onActionCallback(this.state.location);
                        }
                    }}
                    stateField=''
                    iconSvg='ico_map_navigate_arrow_blue'
                    iconSize='stations-map-navigate-arrow'
                />
            </React.Fragment>
        );
    }

}

MapFilterContainer.defaultProps = {
    viewMode: 'NEW',
};

MapFilterContainer.propTypes = {
    onActionCallback: PropTypes.func,
};

export default withTranslation()(MapFilterContainer);
